<div class="flex h-full w-full max-w-[600px] flex-col items-center justify-center">
  <div class="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[var(--primary-90)]">
    <mat-icon class="h-8 w-8 text-3xl text-[var(--primary-10)]">chat</mat-icon>
  </div>
  <h2 class="py-3 text-3xl leading-10 text-[var(--neutral-variant-10)]">
    {{ 'messages.emptyState.title' | translate }}
  </h2>
  <p class="text-center text-base leading-6 text-[var(--neutral-variant-30)]">
    {{ 'messages.emptyState.subtitle' | translate }}
  </p>
</div>
